import { AvvirEvent } from "type_aliases";
import { FloorBuiltElementCounts } from "../../../services/reducers/domain/reduce_floor_built_element_counts";

export type FloorBuiltElementCountsLoadedEvent = AvvirEvent<typeof FLOOR_BUILT_ELEMENT_COUNTS_LOADED, {
  projectId: string,
  builtElementCounts: FloorBuiltElementCounts
}>

const floorBuiltElementCountsLoaded = (projectId: string, builtElementCounts: FloorBuiltElementCounts): FloorBuiltElementCountsLoadedEvent => ({
  type: FLOOR_BUILT_ELEMENT_COUNTS_LOADED,
  payload: {
    projectId,
    builtElementCounts
  }
});

export const FLOOR_BUILT_ELEMENT_COUNTS_LOADED = "floor_built_element_counts_loaded";

export default floorBuiltElementCountsLoaded;
